import React from "react";
import styled from "styled-components";

const Field = styled.input`
  background: #dee6f7;
  border: none;
  border-radius: 100px;
  color: #516375;
  font-family: DM Sans, sans-serif;
  font-size: 1.25rem;
  height: 56px;
  padding: 0px 28px;
  outline: none;
  width: 100%;

  @media (max-width: 900px) {
    font-size: 1rem;
    font-weight: 400;
    height: 38px;
    padding: 0px 16px;
  }
`;

export const Input = (props) => {
  return (
    <Field onChange={props.onChange} value={props.value} placeholder={props.placeholder} type={props.type} />
  );
};
